import PropTypes from 'prop-types';
import BillingAddressProp from './billingAddressProp';

const propType = {
  billingAddress: PropTypes.shape(BillingAddressProp.propType),
  businessType: PropTypes.string,
  invoiceEmail: PropTypes.string,
  taxId: PropTypes.string,
  taxCode: PropTypes.string,
  taxType: PropTypes.string,
  billingLanguage: PropTypes.string,
};

const defaultProp = {
  billingAddress: BillingAddressProp.defaultProps,
  businessType: '',
  invoiceEmail: '',
  taxId: '',
  taxCode: 'lu_vat',
  taxType: 'eu_vat',
  billingLanguage: 'en',
};

export default { propType, defaultProp };
